import styled from "styled-components";

export const Main = styled.main`
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  flex-direction: column;
  min-height: 100vh;
`;

export const Content = styled.div`
  display: flex;
  flex-grow: 1;
  max-width: 1240px;
  width: 92%;
  margin: 0 auto;
`;
